const FEATURE_FLAGS = {
  OP_DISABLED: 'op_disabled',
  SUPPORT_PAGE_DISABLED: 'support_page_disabled',
  MOBILE_LOGIN_LINK_DISABLED: 'mobile_login_link_disabled',
  OP_MAINTENANCE: 'op_maintenance',
  ETS_AGENT_DESKTOP: 'ets_agent_desktop',
  ETS_CRAFTSMAN_MOBILE: 'ets_craftsman_mobile',
  QUICKORDERING_ENABLED: 'quickordering_enabled',
  USER_MANAGEMENT_DISABLED: 'user_management_disabled',
  LAST_ONLINE_BADGE_ENABLED: 'last_online_badge_enabled',
  ETS_CRAFTSMAN_DESKTOP: 'ets_craftsman_desktop',
  MARK_READ_ENABLED: 'agents_mark_as_read_enabled',
  PROCESS_QUANTITY_ENABLED: 'process_quantity_enabled',
  BEAMER_CHAT_ENABLED: 'beamer_chat_enabled',
  AGENTS_CHAT_CREATION_WITH_MULTIPLE_CRAFTSMEN: 'agents_chat_creation_with_multiple_craftsman',
} as const;

export default FEATURE_FLAGS;
